import interceptor from 'helpers/interceptor'
import options from 'helpers/options'

const request = {
    get: async (url, source = '') => {
        const option = options('get', url, {}, source)
        const promiseResult = await interceptor.request(option)
        return promiseResult ? promiseResult.data : []
    },
    post: async (url, params) => {
        const option = options('post', url, params)
        const promiseResult = await interceptor.request(option)
        return promiseResult ? promiseResult.data : []
    },
    patch: async (url, params) => {
        const option = options('patch', url, params)
        const promiseResult = await interceptor.request(option)
        return promiseResult ? promiseResult.data : []
    },
    put: async (url, params, source, fileType, extraParams) => {
        const option = options(
            'put',
            url,
            params,
            source,
            fileType,
            extraParams
        )
        const promiseResult = await interceptor.request(option)
        return promiseResult ? promiseResult.data : []
    },
    delete: async url => {
        const option = options('delete', url, {})
        const promiseResult = await interceptor.request(option)
        return promiseResult ? promiseResult.data : []
    },
}

export default request
